import React from 'react';
import { ImagePlaceholder } from './ImagePlaceholder';
import { bonuses, bonusesIntro } from '../data/bonuses';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="bg-white" data-id="element-35" data-mp="pm2ajt1et9fg">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-36" data-mp="aua9mm2d3xx9">
        <span className="inline-block border border-brass/50 bg-paper px-3 py-1.5 font-mono text-[10px] uppercase leading-none tracking-label text-slate rounded-sharp" data-id="element-37" data-mp="fteg34xwjhjw">
          {bonusesIntro.badge}
        </span>

        <h2 id="bonuses-heading" className="mt-7 max-w-[36rem] font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-ink md:text-[44px]" data-id="element-38" data-mp="5x1l83qmexnk">
          {bonusesIntro.title}
        </h2>

        <p className="mt-5 max-w-[40rem] text-[17px] leading-[1.65] text-slate md:text-[18px]" data-id="element-39" data-mp="3t2smeojoagp2">
          {bonusesIntro.intro}
        </p>

        <ul className="mt-14 space-y-6" data-id="element-40" data-mp="1r9uyn74r6eaz">
          {bonuses.map(bonus => <li key={bonus.number} className="grid gap-6 border border-brass/30 bg-white p-6 shadow-paper rounded-sharp md:grid-cols-[35%_1fr] md:gap-8 md:p-7" data-id="element-41" data-mp="3ieg6r1msq2zs">
              <ImagePlaceholder alt={bonus.imageAlt} className="min-h-[112px] md:min-h-[160px]" data-id="element-42" data-mp="3r6qgkhts46gi" />

              <div className="flex flex-col justify-center" data-id="element-43" data-mp="3n552wu9f7o59">
                <p className="font-mono text-[10px] uppercase tracking-label text-slate" data-id="element-44" data-mp="3n5y99u4gwbmv">
                  {bonus.number}
                </p>

                <h3 className="mt-3 font-serif text-[23px] font-semibold leading-[1.2] text-ink md:text-[27px]" data-id="element-45" data-mp="2ugr0m2bau5nw">
                  {bonus.title}
                </h3>

                <p className="mt-3 font-mono text-[12px] uppercase tracking-label" data-id="element-46" data-mp="38e5v3lget3mq">
                  <span className="text-brick line-through" data-id="element-47" data-mp="33fujp6agul2e">{bonus.price}</span>{' '}
                  <span className="text-brass" data-id="element-48" data-mp="noq5uuwu9mz7">→ Free</span>
                </p>

                <p className="mt-4 text-[16px] leading-[1.65] text-slate" data-id="element-49" data-mp="irq4gxaxp8ef">{bonus.body}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}